import React from "react";
import ErrorPage from "../Notification/Error";

function Personal({ props }) {
  const { data, update, onChange, isError, loading, onGender } = props;

  return (
    <div className="mb-10 lg:w-3/4">
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 lg:gap-20 ">
        <div name="first-name-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            Nama Depan
          </p>
          <input
            disabled={loading}
            onChange={onChange}
            value={update.first_name}
            name="first_name"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="John"
          />

          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "first_name")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
        <div name="last-name-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            Nama Belakang
          </p>
          <input
            disabled={loading}
            onChange={onChange}
            value={update.last_name}
            name="last_name"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Doe"
          />
          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "last_name")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 lg:gap-20 mt-1">
        <div name="gender-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            Jenis Kelamin
          </p>
          <select
            disabled={loading}
            onChange={(e) => onGender(e)}
            value={update.gender ? update.gender : 1}
            name="gender"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Harap pilih jenis kelamin anda"
          >
            <option value={1}>Laki-laki</option>
            <option value={2}>Perempuan</option>
          </select>
          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "gender")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
        <div name="tempat-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            Tempat Lahir
          </p>
          <input
            disabled={loading}
            onChange={onChange}
            value={update.tempat_lahir}
            name="tempat_lahir"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Masukkan tempat lahir anda"
          />
          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "tempat_lahir")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 lg:gap-20 ">
        <div name="last-name-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            Tanggal Lahir
          </p>
          <input
            type="date"
            disabled={loading}
            onChange={onChange}
            value={update.tgl_lahir !== "0001-01-01" ? update.tgl_lahir : ""}
            name="tgl_lahir"
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Doe"
          />
          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "tgl_lahir")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
        <div name="phone-form" className="mb-6">
          <p className="login-title-form mb-3 text-xl lg:text-2xl">
            No. Telepon
          </p>
          <input
            disabled={loading}
            onChange={onChange}
            value={update.no_hp === 0 ? undefined : update.no_hp}
            name="no_hp"
            maxLength={13}
            className={`${
              loading ? "input-disabled" : "form-input"
            } outline-none w-full p-3`}
            placeholder="Masukkan nomor telepon anda"
          />
          {isError
            ? isError.length > 0
              ? isError
                  .filter((it) => it.type === "no_hp")
                  .map((its, idx) => (
                    <ErrorPage
                      key={idx}
                      props={{ idx, message: its.message }}
                    />
                  ))
              : null
            : null}
        </div>
      </div>

      <div name="email-form" className="mb-6">
        <p className="login-title-form mb-3 text-xl lg:text-2xl">Email</p>
        <input
          disabled
          value={data?.email ?? ""}
          name="email"
          className={`input-disabled outline-none w-full p-3`}
          placeholder="Masukkan email anda"
        />
      </div>

      <div name="ktp-form" className="mb-6">
        <p className="login-title-form mb-3 text-xl lg:text-2xl">No. KTP</p>
        <input
          disabled
          value={data?.nik ?? undefined}
          name="no_ktp"
          className={`input-disabled outline-none w-full p-3`}
          placeholder="Masukkan nomor KTP anda"
        />
      </div>
    </div>
  );
}

export default Personal;
